var map = {
	"./VULlogo.png": "d272",
	"./backgroundimg.jpg": "62c4",
	"./banner.jpg": "4c4a",
	"./banner1.jpg": "ba57",
	"./books.gif": "50f3",
	"./favicon.png": "99dd",
	"./financial-contract.png": "24c4",
	"./graduation-ceremony.png": "3f54",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./message.png": "eda7",
	"./moodle.gif": "e24c",
	"./mydha.png": "324f",
	"./mydha1 (2).png": "e833",
	"./online_order.jpg": "56cc",
	"./online_order.png": "066d",
	"./payment-info.png": "eecf",
	"./pubmedlogo.png": "7fbe",
	"./student.jpg": "f0cc",
	"./turnitin.png": "8933",
	"./vul.png": "3b6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";